import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import Table from "../../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../../core/common/datePicker";
import {
  allClass,
  allSection,
  gender,
  names,
  status,
} from "../../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../../core/common/commonSelect";
import TooltipOption from "../../../../core/common/tooltipOption";
import UserService from "../../../network/services/UserService";
import StudentModals from "../../../peoples/students/studentModals";
import { getUser } from "../../../network/auth/Auth";
import Select from "react-select";
import { Button, Modal, Toast } from "react-bootstrap";

const AcademyYearList = () => {
  const routes = all_routes;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  const buttonRef2 = useRef<HTMLSpanElement>(null);
  const buttonRef1 = useRef<HTMLSpanElement>(null);




  const selectionTermStructure = [
    { value: "two_sem", label: "Two Semesters" },
    { value: "two_sem_qua", label: "Two Semesters subdivided by Quarters" },
    { value: "two_sem_final", label: "Two Semesters subdivided by Quarters and Final Exams" },
    { value: "three_sem", label: "Three Trimesters" },
    { value: "four_Quarter", label: "Four Quarters" },
    { value: "final_year", label: "Final Year Grades subdivided by Quarters" },
    { value: "others", label: "Other(overlapping terms,custom schedules)" },
  ];

  // Définir le type pour vos données d'option
  type OptionType = {
    value: string;
    label: string;
  };


  interface Option {
    id: any;
    name: any;
  }


  const [isActionSuccessful, setIsActionSuccessful] = useState(false);
  const [isActionSuccessfulEdit, setIsActionSuccessfulEdit] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [academyTerms, setAcademyTerms] = useState<OptionType[]>([]);
  const [academyYears, setAcademyYears] = useState<any[]>([]);

  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);


  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>({
    name: '',
    start_date: '',
    end_date: '',
    operating_branch_id: '',
    term_structure: '',
  });




  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowDangerToast(false);
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, [showDangerToast]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSuccessToast(false);
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, [showSuccessToast]);

  const [formData, setFormData] = useState({
    name: '',
    start_date: '',
    end_date: '',
    operating_branch_id: '',
    term_structure: '',
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleInputChangeEdite = (e: any) => {
    const { name, value } = e.target;
    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: value
    }));
  };

  const handleInputChangeEdite2 = (e: any) => {
    const { name, value } = e.target;
    console.log(`Changed ${name} to ${value}`); // Debugging

    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: {
        id: value,
        //name: branches.find((branch: any) => branch.id === value)?.name || '' // Assurez-vous que `name` est mis à jour correctement
      }
    }));
  };










  const [branch, setBranch] = useState<any>();
  const branches = useState<any>([]);




  const [drivers, setDrivers] = useState<any>([]);
  const getAllDrivers = () => {


    UserService.getDrivers((response: any) => {
      console.log(response.data)

      if (response?.success === true) {
        setDrivers(response.data)
        console.log(response.data)
      }
    })
  }

  useEffect(() => {
    getAllDrivers()
  }, [])


  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a: any, b: any) => a.start_date.length - b.start_date.length,
    },
    {
      title: "amount",
      dataIndex: "balance",
      render: (record: any) => (
        <div className="d-flex flex-wrap gap-2">

          <span className="badge rounded-pill bg-success text-white mr-2">
            {record} Fcfa
          </span>

        </div>
      ),
      sorter: (a: any, b: any) => a.end_date.length - b.end_date.length,
    },

    {
      title: "Action",
      // dataIndex: "action",
      render: (record: any) => (
        <div className="d-flex align-items-center">
          <div className="dropdown">
            <Link
              to="#"
              className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"

            >
              <i className="ti ti-dots-vertical fs-14" />
            </Link>
            <ul className="dropdown-menu dropdown-menu-right p-3">

              <li>
                <Link className="dropdown-item rounded-1" to='#' >
                  <i className="ti ti-edit-circle me-2" />
                  Edit
                </Link>
              </li>

              <li>
                <Link className="dropdown-item rounded-1" to="#" data-bs-toggle="modal" data-bs-target="#delete-modal">
                  <i className="ti ti-trash-x me-2" />
                  Delete
                </Link>
              </li>
            </ul>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Wallet account List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Wallet account</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Wallet account
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />

              {getUser().role === "school_admin" && (<div className="mb-2">
                <Link to="#" className="btn btn-primary d-flex align-items-center" onClick={handleShow}>
                  <i className="ti ti-square-rounded-plus me-2" />
                  credit account
                </Link>

              </div>)}
            </div>
          </div>
          {/* /Page Header */}
          {/* Academic Year List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Wallet account List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 pb-0 border-bottom">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Class</label>
                              <CommonSelect
                                className="select"
                                options={allClass}
                                defaultValue={allClass[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Section</label>
                              <CommonSelect
                                className="select"
                                options={allSection}
                                defaultValue={allSection[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Name</label>
                              <CommonSelect
                                className="select"
                                options={names}
                                defaultValue={names[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Gender</label>
                              <CommonSelect
                                className="select"
                                options={gender}
                                defaultValue={gender[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={status}
                                defaultValue={status[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link to={routes.studentGrid} className="btn btn-primary" onClick={handleApplyClick}>
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                  <Link
                    to={routes.academyYearList}
                    className="active btn btn-icon btn-sm me-1 primary-hover"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={routes.academyYearGrid}
                    className="btn btn-icon btn-sm bg-light primary-hover"
                  >
                    <i className="ti ti-grid-dots" />
                  </Link>
                </div>
                <div className="dropdown mb-3">
                  <Link to="#" className="btn btn-outline-light bg-white dropdown-toggle" data-bs-toggle="dropdown">
                    <i className="ti ti-sort-ascending-2 me-2" />
                    {branch}
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li >
                      <a className="dropdown-item rounded-1" >
                        All
                      </a>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              <Table dataSource={drivers} columns={columns} />
            </div>
          </div>
          {/* /Academic Year List */}
        </div>
      </div>
      {/* /Page Wrapper */}
      <StudentModals />







      <Modal show={showModal} onHide={handleClose} >
        <Modal.Header >
          <Modal.Title>Add Academic Year</Modal.Title>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={handleClose}

          >
            <i className="ti ti-x" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" placeholder="Name" name="name" value={formData.name}
                      onChange={handleInputChange} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Start date</label>
                    <input type="date" className="form-control" name="start_date" value={formData.start_date}
                      onChange={handleInputChange} />

                  </div>
                  <div className="mb-3">
                    <label className="form-label">End date</label>
                    <input type="date" className="form-control" name="end_date"
                      value={formData.end_date}
                      onChange={handleInputChange} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Term Structure</label>
                    <select

                      className="select react-select form-control"
                      name="term_structure"
                      onChange={handleInputChange}
                    >
                      <option >Select Term Structure</option>
                      {selectionTermStructure && selectionTermStructure?.map((item: any) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                      ))}

                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Branch</label>
                    <select

                      className="select react-select form-control"
                      name="operating_branch_id"
                      onChange={handleInputChange}
                    >
                      <option >Select Branch</option>
                      {branches && branches?.map((item: any) => (
                        <option key={item.id} value={item.id}>{item.name}</option>
                      ))}

                    </select>
                  </div>


                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span
                className="btn btn-light me-2"
                onClick={handleClose}
              >
                Cancel
              </span>
              <Link to="#" className="btn btn-primary"   >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm align-middle me-1"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </>
                ) : "Add Academic year"}

              </Link>
            </div>
          </form>
        </Modal.Body>

      </Modal>

      <Modal show={showModal2} onHide={handleClose2} >
        <Modal.Header >
          <Modal.Title>Edit Academic Year</Modal.Title>
          <button
            type="button"
            className="btn-close custom-btn-close"
            onClick={handleClose2}

          >
            <i className="ti ti-x" />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" placeholder="Name" name="name" value={selectedRecord?.name}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Start date</label>
                    <input type="date" className="form-control" name="start_date"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">End date</label>
                    <input type="date" className="form-control" name="end_date"
                      value={selectedRecord?.end_date}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Term Structure</label>
                    <select

                      className="select react-select form-control"
                      name="term_structure"
                      value={selectedRecord?.term_structure} // Valeur sélectionnée

                    >

                      {selectionTermStructure && selectionTermStructure?.map((item: any) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                      ))}

                    </select>
                  </div>


                  <div className="mb-3">
                    <label className="form-label">Branch</label>
                    <select
                      className="select react-select form-control"
                      name="operating_branch_id"
                      value={selectedRecord?.operating_branch_id?.id || ''} // Assurez-vous que cette valeur correspond à une option
                      onChange={handleInputChangeEdite2}
                    >
                      <option value="">Select a branch</option>
                      {branches && branches.map((item: any) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>

                  </div>


                </div>
              </div>
            </div>
            <div className="modal-footer">
              <span
                className="btn btn-light me-2"
                onClick={handleClose2}
              >
                Cancel
              </span>
              <Link to="#" className="btn btn-primary"  >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm align-middle me-1"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </>
                ) : "Edit Academic year"}

              </Link>
            </div>
          </form>
        </Modal.Body>

      </Modal>

      <Toast
        show={showDangerToast}
        onClose={handleDangerToastClose}
        id="dangerToast"
        className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ minWidth: "200px!important" }}
      >
        <Toast.Header closeButton className="bg-danger text-fixed-white">
          <strong className="me-auto">Message</strong>
          <span
            className="cursor-pointer"
            onClick={handleDangerToastClose}
            aria-label="Close"
            style={{ cursor: "pointer" }}
          />
        </Toast.Header>
        <Toast.Body>
          {/* Add your toast content here */}
          {errorMessage}
        </Toast.Body>
      </Toast>

      <Toast
        show={showSuccessToast}
        onClose={handleSuccessToastClose}
        id="successToast"
        className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >

        <Toast.Body>
          {/* Add your toast content here */}
          {successMessage}
        </Toast.Body>
      </Toast>
    </>
  );
};

export default AcademyYearList;

